var EmailFormIntlMainView, EmailFormIntlVerticalView, SharedAjaxError,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormIntlMainView = require("./main_view");

SharedAjaxError = require("../../../../../shared/frontend/views/ajax_error_view");

EmailFormIntlVerticalView = (function(superClass) {
  extend(EmailFormIntlVerticalView, superClass);

  function EmailFormIntlVerticalView() {
    return EmailFormIntlVerticalView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlVerticalView.prototype.toHash = function() {
    var hash;
    hash = EmailFormIntlMainView.prototype.toHash.call(this);
    hash.isVertical = true;
    return hash;
  };

  EmailFormIntlVerticalView.prototype.renderTicketCreateError = function() {
    var errorView;
    this.hideSubmitButton();
    errorView = new SharedAjaxError();
    return errorView.render({
      container: $('#v2-step3-form'),
      isVertical: true
    });
  };

  EmailFormIntlVerticalView.prototype.hideSubmitButton = function() {
    return $('.step-three .submit-button').hide();
  };

  EmailFormIntlVerticalView.prototype.submitForm = function(data) {
    return createTicket(data, this.renderSuccess, this.renderTicketCreateError, $('#v2-step3-form'));
  };

  return EmailFormIntlVerticalView;

})(EmailFormIntlMainView);

module.exports = EmailFormIntlVerticalView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9JTlRML3ZlcnRpY2FsX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9JTlRML3ZlcnRpY2FsX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsaUVBQUE7RUFBQTs7O0FBQUEscUJBQUEsR0FBd0IsT0FBQSxDQUFRLGFBQVI7O0FBQ3hCLGVBQUEsR0FBa0IsT0FBQSxDQUFRLHNEQUFSOztBQUVaOzs7Ozs7O3NDQUVKLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtJQUFBLElBQUEsR0FBTyxxQkFBcUIsQ0FBQSxTQUFFLENBQUEsTUFBTSxDQUFDLElBQTlCLENBQW1DLElBQW5DO0lBQ1AsSUFBSSxDQUFDLFVBQUwsR0FBa0I7V0FDbEI7RUFITTs7c0NBS1IsdUJBQUEsR0FBeUIsU0FBQTtBQUN2QixRQUFBO0lBQUEsSUFBQyxDQUFBLGdCQUFELENBQUE7SUFDQSxTQUFBLEdBQVksSUFBSSxlQUFKLENBQUE7V0FDWixTQUFTLENBQUMsTUFBVixDQUFpQjtNQUFDLFNBQUEsRUFBVyxDQUFBLENBQUUsZ0JBQUYsQ0FBWjtNQUFpQyxVQUFBLEVBQVksSUFBN0M7S0FBakI7RUFIdUI7O3NDQUt6QixnQkFBQSxHQUFrQixTQUFBO1dBQ2pCLENBQUEsQ0FBRSw0QkFBRixDQUErQixDQUFDLElBQWhDLENBQUE7RUFEaUI7O3NDQUdsQixVQUFBLEdBQVksU0FBQyxJQUFEO1dBQ1YsWUFBQSxDQUFhLElBQWIsRUFBbUIsSUFBQyxDQUFBLGFBQXBCLEVBQW1DLElBQUMsQ0FBQSx1QkFBcEMsRUFBNkQsQ0FBQSxDQUFFLGdCQUFGLENBQTdEO0VBRFU7Ozs7R0FmMEI7O0FBa0J4QyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
